$(document).ready(function(){
$(".our_promise .owl-carousel").owlCarousel({
   loop: true, 
   autoplay: true,
   nav: true,
   autoplayTimeout: 3000,
   autoplaySpeed: 1000, 
   autoplayHoverPause: true,
   responsive: {
   0: {
     items: 1,
     margin: 10
   },
   768: {
     items: 2,
     margin: 20
   },
   1025: {
    items: 3,
    margin: 28
   }
   }
  });
});


$(document).ready(function(){
$(".about_our_team .owl-carousel").owlCarousel({
   loop: true, 
   autoplay: true,
   dots: true,
   autoplayTimeout: 3000,
   autoplaySpeed: 1000, 
   autoplayHoverPause: true,
   responsive: {
   0: {
     items: 2,
     margin: 10
   },
   768: {
     items: 3,
     margin: 15
   },
   1025: {
    items: 4,
    margin: 20
   }
   }
  });
});

$(document).ready(function(){
$(".achievements .owl-carousel").owlCarousel({
   loop: true, 
   autoplay: true,
   nav: true,
   autoplayTimeout: 3000,
   autoplaySpeed: 1000, 
   autoplayHoverPause: true,
   responsive: {
   0: {
     items: 1,
     margin: 10
   },
   768: {
     items: 2,
     margin: 20
   },
   1025: {
    items: 2,
    margin: 28
   }
   }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const tabHeadings = document.querySelectorAll(".tab-heading");
  const tabContents = document.querySelectorAll(".tab-content");

  tabHeadings.forEach((heading) => {
    heading.addEventListener("click", function() {
      // Remove active class from all headings and contents
      tabHeadings.forEach(h => h.classList.remove("active"));
      tabContents.forEach(content => content.classList.remove("active"));

      // Add active class to the clicked heading and corresponding content
      heading.classList.add("active");
      const index = heading.getAttribute("data-tab-index");
      document.querySelector(`#tab-content-${index}`).classList.add("active");
    });
  });
});


jQuery(document).ready(function($) {
  $('.faq_item.active .faq_content').show();
  $('.faq_item h4').click(function() {
    var $this = $(this);
    var $content = $this.next('.faq_content');
    // Toggle the clicked item
    $this.toggleClass('active');
    $content.slideToggle('500');
    // Hide other panels
    $('.faq_item').not($this.closest('.faq_item')).find('.faq_content').slideUp('fast');
    $('.faq_item').not($this.closest('.faq_item')).find('h4').removeClass('active');
  });
});


jQuery(document).ready(function ($2) {
    jQuery(".footer .footer__content-top").find(".footer-block__heading").click(function () {
        $2(window).width() < 580 && (
            jQuery(this).toggleClass("active"),
            jQuery(this).next().slideToggle("fast"),
            jQuery(".footer-block__heading + .footer-block__details-content").not(jQuery(this).next()).slideUp("fast")
        );
    });
});

jQuery(document).ready(function ($2) {
    jQuery(".main-blog").find(".blog-sidebar__toggle").click(function () {
        $2(window).width() < 768 && (
            jQuery(this).toggleClass("active"),
            jQuery(this).next().slideToggle("fast"),
            jQuery(".blog-sidebar__toggle + .blog_sidebar").not(jQuery(this).next()).slideUp("fast")
        );
    });
});


jQuery(document).on('click', '.benifit-toggle', function () {
    jQuery(this).toggleClass('active');
    jQuery(this).next('.benifit-toggle-content').slideToggle('fast');
    jQuery('.benifit-toggle + .benifit-toggle-content').not(jQuery(this).next()).slideUp('fast');
});



// window.addEventListener('scroll', function() {
//     const header = document.querySelector('.header-wrapper');
//     if (window.scrollY > 118) {
//         header.classList.add('fixed');
//     } else {
//         header.classList.remove('fixed');
//     }
// });

// let lastScrollTop = 0;
// window.addEventListener('scroll', function() {
//     const header = document.querySelector('.header-wrapper');
//     let currentScroll = window.scrollY;
//     if (currentScroll < lastScrollTop) {
//         header.classList.add('fixed');
//     } else {
//         header.classList.remove('fixed');
//     }
//     lastScrollTop = currentScroll;
// });

// let lastScrollTop = 0;
// window.addEventListener('scroll', function() {
//     const header = document.querySelector('.header-wrapper');
//     let currentScroll = window.scrollY;
//     if (currentScroll === 0) {
//         header.classList.remove('fixed');
//     } else if (currentScroll < lastScrollTop) {
//         header.classList.add('fixed');
//     } else {
//         header.classList.remove('fixed');
//     }

//     lastScrollTop = currentScroll;
// });



